import React, { useState } from "react";

const MessageRedirect = (props) => {
  const code = props.item && props.item.code;
  const url = props.item.url;
  const data = props.item && props.item.text_data;

  const [clicked, setClicked] = useState(false);

  return props?.isFallback && props?.item?.text === "Chat with us" ? (
    <>
      <button
        className={
          props.isFallback
            ? "chat-label-fallback action-tab"
            : "chat-labelnohover action-tab"
        }
        id="main-tab1"
        style={{
          color: "white",
          pointerEvents: clicked && "none",
          opacity: clicked && "0.5",
        }}
        onClick={() => {
          if (!props.disable) {
            props.handleClick(code);
            props.setTextOnClick(props.item.text);
            setClicked(true);
          }
          window.open(props.item.url);
        }}
      >
        {props?.item?.text}
      </button>
    </>
  ) : (
    <span
      className={
        !props.disable
          ? "chat-label action-tab "
          : "chat-labelnohover action-tab"
      }
      id="main-tab1"
    >
      {data && data.data ? (
        <form
          target="targetWindow"
          action={!props.disable && url}
          method="POST"
        >
          <input
            type="hidden"
            name={Object.keys(data.data)[0]}
            value={data.data[Object.keys(data.data)[0]]}
          ></input>
          <input
            type="submit"
            value={props.item.text}
            onClick={() => {
              if (!props.disable) {
                props.handleClick(code);
                props.setTextOnClick(props.item.text);
              }
            }}
            style={{
              color: props.disable ? "grey" : "inherit",
              border: "none",
              background: "none",
              fontFamily: "VoltePlay-Medium, sans-serif",
              fontSize: "15px",
            }}
          ></input>
        </form>
      ) : data && data !== "undefined" ? (
        <form target="_blank" action={!props.disable && url} method="POST">
          <input
            type="hidden"
            name={Object.keys(data)[0]}
            value={data[Object.keys(data)[0]]}
          ></input>
          <input
            type="submit"
            value={props.item.text}
            onClick={() => {
              if (!props.disable) {
                props.handleClick(code);
                props.setTextOnClick(props.item.text);
              }
            }}
            style={{
              fontFamily: "VoltePlay-Medium, sans-serif",
              fontSize: "15px",
              color: props.disable ? "grey" : "inherit",
              border: "none",
              background: "none",
            }}
          ></input>
        </form>
      ) : (
        <span
          onClick={() => {
            if (!props.disable) {
              props.handleClick(code);
              props.setTextOnClick(props.item.text);
            }
            window.open(props.item.url);
          }}
          style={{
            color: props.disable ? "grey" : "inherit",
            fontFamily: "VoltePlay-Medium, sans-serif",
            fontSize: "15px",
          }}
          target="_blank"
        >
          {props.item.text}
        </span>
      )}
    </span>
  );
};

export default MessageRedirect;
